import { call, put, takeEvery } from "redux-saga/effects"

import { GET_DEPARTMENTS, ADD_NEW_DEPARTMENT, UPDATE_DEPARTMENT, DELETE_DEPARTMENT } from "./actionTypes";
import {
    getDepartmentsSuccess,
    getDepartmentsFail,
    addDepartmentSuccess,
    addDepartmentFail,
    updateDepartmentSuccess,
    updateDepartmentFail,
    deleteDepartmentSuccess,
    deleteDepartmentFail,
   
} from "./actions"

import {
    getDepartments,
    addNewDepartment,
    updateDepartment,
    deleteDepartment,
   
} from "helpers/departments/departments_backend_helper";
import { toast } from "react-toastify";

function* fetchDepartments() {
    try {
        const response = yield call(getDepartments)
        yield put(getDepartmentsSuccess(response))
    } catch (error) {
        yield put(getDepartmentsFail(error))
    }
}

function* onAddNewDepartment({ payload }) {
    try {

        
        const response = yield call(addNewDepartment, payload)

        console.log("RESPONSE:", response);
        yield put(addDepartmentSuccess(response.department))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addDepartmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateDepartment({ payload: data }) {
    try {
        const response = yield call(updateDepartment, data)
        yield put(updateDepartmentSuccess(response))
        toast.success("department  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateDepartmentFail(error))
        toast.error("department  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateDepartment({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateDepartment, payload)
        yield put(updateDepartmentSuccess(response.department))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateDepartmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteDepartment({ payload: data }) {

    try {
        const response = yield call(deleteDepartment, data)
        yield put(deleteDepartmentSuccess(response.departmentId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteDepartmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* departmentSaga() {
    yield takeEvery(GET_DEPARTMENTS, fetchDepartments)
    yield takeEvery(ADD_NEW_DEPARTMENT, onAddNewDepartment)
    yield takeEvery(UPDATE_DEPARTMENT, onUpdateDepartment)
    yield takeEvery(DELETE_DEPARTMENT, onDeleteDepartment)
}

export default departmentSaga;